// extracted by mini-css-extract-plugin
export default {"cartContainer":"RG","summarycontent":"SG","offset":"TG","leaf":"UG","summaryclosed":"VG","summaryheader":"WG","summaryitems":"XG","summaryprice":"YG","buttonopen":"ZG","buttondown":"aH","summaryfixed":"bH","usdnotification":"cH","renew":"eH","promowrapper":"fH","ordersummarywrap":"gH","simplewrap":"hH"};
    if(module.hot) {
      // 1715188236503
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  